import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import establishmentStore from "@/entities/establishment/model/establishment.store"
import { upload } from "@/redux/_upload.actions"
import fileToImage from "@/utils/file-to-image"
import UploadButtonWidget from "@/widgets/upload-button.widget"
import { toast } from "react-toastify"

interface Props {
  onUploaded?: () => void
}

export default function EstablishmentSiteImageUpload({ onUploaded }: Props) {
  const dispatch = useAppDispatch()
  const establishment = useAppSelector(establishmentStore.selectors.active)

  async function uploadFile(files: File[]) {
    if (!files.length || !establishment.id) return

    const image = await fileToImage(files[0])
    const uploadResponse: any = await dispatch(upload(establishment.id, image, "Establishments", "image/png"))
    if (uploadResponse !== "OK") {
      toast("L'import de la vue d'ensemble a échoué.", { type: "error" })
      return
    }

    const establishmentWithImage = { ...establishment, siteImageUploaded: true }
    const updated = await establishmentStore.endpoints.update(establishmentWithImage)
    if (updated?.error) {
      toast("L'image a été importée, mais l'établissement n'a pas pu être mis à jour.", { type: "error" })
      return
    }

    dispatch(establishmentStore.actions.replace(updated))
    dispatch(establishmentStore.actions.setActive(updated))
    onUploaded?.()
  }

  return <UploadButtonWidget acceptedFiles="image/png" onUpload={uploadFile} />
}
